import {useFetchRushPersonalScoresQuery} from '@api';
import {useRushQueryParams} from '@utils';
import {RushTypes} from '@types';
import {RushScoreTable} from './RushScoreTable';

export const RushTabPersonal = () => {
    const {rushType, filter, sort, setSort} = useRushQueryParams();

    const {
        data: personalScores,
        isFetching,
        isError,
        refetch,
    } = useFetchRushPersonalScoresQuery({
        rushType: rushType ?? RushTypes.TYPE_3_MINUTES,
        filter,
        sort,
        limit: 20,
    });

    return (
        <RushScoreTable
            data={personalScores?.entries || []}
            sort={sort}
            setSort={setSort}
            isLoading={isFetching}
            isError={isError}
            onRetry={refetch}
        />
    );
};
